/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import { Column, Container, Row } from '../../../styles/Grid';
import Picture from '../../ui/Picture';
import DotComponent from '../../ui/DotComponent';
import * as Styles from './index.style';
import Spacer from '../../ui/Spacer';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import { composeStringToId } from '../../../utils/stringToId';
import { CLOUDINARY_BASE_VALUES } from '../../../utils/constants';
import { Breakpoints } from '../../../styles/Grid/GridSizes';
import DummyData from './data.json';
import BulletIcon from './bulletIcon.svg';
import SquareImg from './Image.png';
import { Icon } from '../../ui/Icon';
import BackgroundImg from './watermark_seo.png';

import { container_resize } from './index.style';
import { Image, RichText } from '@sitecore-jss/sitecore-jss-react';
import { get } from 'lodash';
const mainImageSizes = {
  [Breakpoints.sm]: {
    ...CLOUDINARY_BASE_VALUES,
    gravity: 'auto:subject',
  },
  [Breakpoints.md]: {
    ...CLOUDINARY_BASE_VALUES,
    width: 232,
    height: 232,
    gravity: 'auto:subject',
  },
  [Breakpoints.lg]: {
    ...CLOUDINARY_BASE_VALUES,
    width: 296,
    height: 296,
    gravity: 'auto:subject',
  },
  [Breakpoints.xl]: {
    ...CLOUDINARY_BASE_VALUES,
    width: 304,
    height: 304,
    gravity: 'auto:subject',
  },
};

class TabHeader extends SafePureComponent {
  safeRender() {
    const { name, label, onChangeTabs, active } = this.props;
    return (
      <li
        css={[Styles.itemTabCss, active && Styles.itemTabActiveCss]}
        key={composeStringToId(label, 'regus-tabs')}
      >
        <button onClick={onChangeTabs} id={label} css={Styles.TabCtaCss}>
          <span data-active={active} css={Styles.textHeaderCss}>
            {/* <Text field={name} /> */}
            {name}
          </span>
        </button>
      </li>
    );
  }
}

TabHeader.displayName = 'TabHeader';

class TabContent extends SafePureComponent {
  getItem = (item, key) => {
    const bulletIcon = get(item, 'fields.Icon.value.src', '');
    const Text = get(item, 'fields.Text.value', '');
    const IconVal = get(item, 'fields.Icon', {});
    return (
      <li key={key}>
        <span className="img_point">
          {/* <img src={item.fields.Icon.value.src} alt="bullet-icon" /> */}

          {bulletIcon && <Icon svgIcon={IconVal.value.src} />}
        </span>
        <span className="textpoint">{Text}</span>
      </li>
    );
  };

  safeRender() {
    const { Tabs, activeTab } = this.props;
    return Tabs.map((item, key) => {
      // const SquareImg = TabImage;
      const TextTitle = get(item, 'TextTitle.value', '');
      const Text = get(item, 'Text.value', '');
      const SelectedFeatures = get(item, 'SelectedFeatures', []);
      const TabImage = get(item, 'TabImage.value.src', '');
      return (
        <div
          key={key}
          css={[
            Styles.contentTabItemCss,
            activeTab === key && Styles.activeContentTab,
            // Styles.activeContentTab,
          ]}
        >
          <div className="left_sec">
            <div className="text_left">
              <h2 className="contentHeadlineCss">
                {TextTitle}
                <DotComponent />
              </h2>
              <div className="contentDescriptionCss">
                {/* <p className="contentDescriptionCss">{content.Text.value}</p> */}
                {Text && <RichText field={item.Text} tag="p" />}
              </div>
              {SelectedFeatures && (
                <ul className="list_point">
                  {SelectedFeatures.map((item, key) => this.getItem(item, key))}
                </ul>
              )}
            </div>
            <div className="img_sec">
              {/* <img src={content.TabImage.value.src} alt="tab-content-img" /> */}
              {TabImage && (
                <Picture
                  image={item.TabImage}
                  imageSizes={mainImageSizes}
                  instantLoad
                />
              )}
            </div>
          </div>
        </div>
      );
    });
  }
}

class SeoModule extends SafePureComponent {
  state = { activeTab: 0 };

  onChangeTab = activeTab => {
    this.setState({ activeTab });
  };
  safeRender() {
    const { fields } = this.props;

    // console.log('zza Seo Module >> ', fields);
    const { activeTab } = this.state;
    const Tabs = get(fields, 'Tabs', []);

    return (
      <Spacer customCss={Styles.containerSizesTop}>
        <Container css={container_resize}>
          {/* <div css={Styles.CommonCss}> */}
          <div className="mid_sec">
            <div className="tab_sec">
              <div className="background_imgleft">
                <img src={BackgroundImg} alt="tab-content-img" />
              </div>

              <div css={Styles.tabHolder}>
                <ul>
                  {Tabs.map((item, key) => {
                    const labelValue = item.TabTitle.value;
                    return (
                      <TabHeader
                        active={key === activeTab}
                        onChangeTabs={() => this.onChangeTab(key)}
                        key={composeStringToId(labelValue, 'regus-tab-header')}
                        name={item.TabTitle.value}
                        label={labelValue}
                      />
                    );
                  })}
                </ul>
                <div className="scroll-shadow"></div>
              </div>
            </div>
            <div className="tab_sec_result">
              <TabContent activeTab={activeTab} Tabs={Tabs} />
            </div>
          </div>

          {/* </div> */}
        </Container>
      </Spacer>
    );
  }
}

export default SeoModule;
